import { createReducer } from "@reduxjs/toolkit";

export const categoryReducer = createReducer({}, {

    getAllCategoryRequest: (state) => {
        state.loading = true
    },

    getAllCategorySuccess: (state, action) => {
        state.loading = false
        state.categories = action.payload.categories
        state.error = null
    },

    getAllCategoryFail: (state, action) => {
        state.loading = false
        state.error = action.payload
    },


    getCategoryRequest: (state) => {
        state.loading = true
    },

    getCategorySuccess: (state, action) => {
        state.loading = false
        state.category = action.payload.category
        state.error = null
    },

    getCategoryFail: (state, action) => {
        state.loading = false
        state.error = action.payload
    },





})